export default function Chip() {
	return {
		MuiChip: {
			styleOverrides: {
				icon: {
					fontSize: '1rem',
				},
			},
		},
	}
}
